import { render } from "./DataTable.vue?vue&type=template&id=3e3c7ece&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=3e3c7ece&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3c7ece"]])

export default __exports__